<template>
  <footer class="custom-footer">
    <div class="row footer-margin">
      <div class="col-md-6 col-sm-4">
        <a target="_blank" href="https://www.hungerhub.com/">
          <img
            src="../assets/img/hh-logo-white.png"
            alt="hungerhub logo"
            text-align="center"
            data-retina="true"
            class="logo-hungerhub"
          />
        </a>

        <div class="address">
          <p>
            hungerhub is Canada's leading catering & office meal delivery
            platform
          </p>
        </div>
      </div>

      <div class="col-md-3 col-sm-4">
        <h3>Made with ♥️ in Canada</h3>

        <div>
          <a
            href="https://www.hungerhub.com/"
            class="download-text"
            target="_blank"
          >
            Learn more about hungerhub
          </a>
        </div>
      </div>

      <div class="col-md-3 col-sm-4" id="newsletter">
        <h3>Need Help?</h3>
        <div class="mt-3">
          <span>
            Start live chat with one of our agents.
            <br />Weekdays : 9 AM-7 PM
          </span>
        </div>
      </div>
    </div>
    <!-- End row -->

    <!-- End container -->
  </footer>
</template>

<script>
import { isLoggedIn } from "../utils/api";

export default {
  name: "GuestFooter",
  data() {
    return {
      loggedIn: false
    };
  },
  methods: {
    isUserLoggedIn() {
      if (isLoggedIn()) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    }
  },
  watch: {
    $route(to, from) {
      this.isUserLoggedIn();
    }
  }
};
</script>

<style scoped lang="scss">
.custom-footer {
  background-color: #383781;

  h3 {
    font-family: Inter, sans-serif;
    line-height: 130%;
    font-weight: 600;
    margin-bottom: 32px;
    color: #fff;
    font-size: 20px;
  }

  span,
  a {
    font-family: Inter, sans-serif;
    color: #fff;
    font-weight: 300;
    font-size: 16px;
  }

  p {
    margin-top: 2px;
    font-family: Inter, sans-serif;
    color: #fff;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 500;
  }

  .download-text {
    margin-bottom: 30px;
    font-family: Inter, sans-serif;
    font-weight: 400;
    text-decoration: underline;
  }

  .app-badge {
    width: 170px;
    height: 50px;
    object-fit: fill;
  }

  .address {
    margin-top: 20px;
    max-width: 358px;
  }
}

footer {
  position: relative;
  z-index: 100;
}

.footer-margin {
  margin: 1% 7%;
}

.style-anchor-tag {
  text-decoration: none;
  border-bottom: 1px solid #b1d3d4;
}

.logo-hungerhub {
  object-fit: contain;
  width: 139px;
  height: 51px;
}

@media (max-width: 615px) {
  .custom-footer {
    h3 {
      margin-bottom: 12px;
      font-size: 16px;
    }

    span,
    a {
      font-size: 13px;
    }

    p {
      font-size: 13px;
    }

    .download-text {
      margin-bottom: 10px;
    }

    .app-badge {
      width: 120px;
      height: 36px;
      object-fit: cover;
    }
    .address {
      margin-top: 0px;
    }
  }
}

@media (max-width: 305px) {
  .custom-footer {
    .app-badge {
      width: 90px;
      height: 26px;
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GuestFooter.vue